import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { NavigationItem } from './navigation-item.interface';

@Injectable({
  providedIn: 'root',
})
export class NavigationLoaderService {
  private readonly _items = new BehaviorSubject<NavigationItem[]>([]);

  public get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor() {
    this.loadNavigation();
  }

  public loadNavigation(): void {
    this._items.next([
      {
        type: 'link',
        label: 'layout.menu.showcase',
        route: '/showcase',
        icon: 'remix:Design/palette-line',
        hoverIcon: 'remix:Design/palette-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'layout.menu.home',
        route: '/home',
        icon: 'remix:Buildings/home-smile-2-line',
        hoverIcon: 'remix:Buildings/home-smile-2-fill',
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: 'link',
        label: 'layout.menu.partners',
        route: '/partners',
        icon: 'remix:Business/briefcase-line',
        hoverIcon: 'remix:Business/briefcase-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'layout.menu.customers',
        route: '/customers',
        icon: 'remix:User & Faces/user-heart-line',
        hoverIcon: 'remix:User & Faces/user-heart-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'layout.menu.team',
        route: '/team',
        icon: 'remix:User & Faces/team-line',
        hoverIcon: 'remix:User & Faces/team-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'external-link',
        label: 'layout.menu.tolt',
        url: 'https://app.tolt.com',
        icon: 'logo:tolt',
      },
    ]);
  }
}
